var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getUserAction } from "slices/user";
import { createListenerMiddleware } from "@reduxjs/toolkit";
let pageIsHidden = false;
const visibilityMiddleware = createListenerMiddleware();
visibilityMiddleware.startListening({
    predicate: () => true,
    effect: (_action, listenerApi) => __awaiter(void 0, void 0, void 0, function* () {
        document.addEventListener("visibilitychange", () => {
            if (document.hidden !== pageIsHidden) {
                pageIsHidden = document.hidden;
                listenerApi.dispatch(getUserAction());
            }
        });
    }),
});
export default visibilityMiddleware.middleware;
